module.exports = __webpack_public_path__ + "modelace-postavy-liposukce_22_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/modelace-postavy-liposukce_22_after.jpg
// module id = 1109
// module chunks = 0